import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import type { ApiResponse, AxiosDataResponse } from '../../../config/api-types'
import { AUTH_ENDPOINTS } from '../../../config/endpoints'
import type { ILoginClient } from '../data/data-sources/i-login-client'
import type { LoginRequest } from '../domain/models/user'

export class LoginService implements ILoginClient {
  constructor(private readonly axios: AxiosInstance) {}
  async login(params: LoginRequest): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
        AUTH_ENDPOINTS.login,
        params,
      )

      if (!result.data.success) {
        return {
          message: result.data.message,
          status: result.status,
          success: result.data.success,
        }
      }

      const data = JSON.stringify({
        userId: result.data.data.userId,
        login: result.data.data.taxId,
        clientId: result.data.data.clientId,
      })

      localStorage.setItem('user', data)

      if (result.data.data.token) {
        localStorage.setItem('token', result.data.data.token)
        sessionStorage.setItem('logged', 'true')
      }

      return {
        message: result.data.message!,
        data: result.data.data,
        status: result.status,
        success: result.data.success,
      }
    } catch (error: any) {
      const axiosError = error as AxiosError<AxiosDataResponse>
      return {
        message: axiosError.response?.data?.message,
        status: axiosError.response?.status!,
        success: false,
      }
    }
  }
}
